import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  highestAchievedRankDescriptionById,
  paidAsRankDescLastMonth,
  rankDescriptionById,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {
  reportFilterCount,
  viewTeamsLoadingState,
} from '/redux/selector/myTeams.selector';
import {withProps} from '/util/selector.util';

import SortButtonTeamOrg from './SortButtonTeamOrg';

export default connect(
  createStructuredSelector({
    userId,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    highestAchievedRank: withProps({coachId: userId})(
      highestAchievedRankDescriptionById,
    ),
    coachCurrentRank: withProps({coachId: userId})(rankDescriptionById),
    viewTeamsReportFilterCount: reportFilterCount,
    isViewTeamsLoading: viewTeamsLoadingState,
  }),
)(SortButtonTeamOrg);
